import { useAuthStore } from '../store/authStore';

/**
 * Base URL del portal paciente de Vita360 (fuente de verdad: el backend SSO).
 * En desarrollo sin sesión SSO se usa el fallback configurable
 * VITE_INTUS_BASE_URL para que la redirección siempre funcione.
 */
export function intusBaseUrl(): string {
  const fromStore = useAuthStore.getState().intusBaseUrl ?? '';
  if (fromStore) {
    return fromStore.replace(/\/+$/, '');
  }
  return (import.meta.env.VITE_INTUS_BASE_URL as string | undefined || 'http://localhost:8000').replace(/\/+$/, '');
}

/**
 * URL de la bienvenida del portal paciente de Vita360, construida sobre la
 * base URL que el SSO entrega (config-driven). Devuelve '' si no hay base
 * configurable.
 */
export function intusWelcomeUrl(): string {
  const base = intusBaseUrl();
  return base ? `${base}/bienvenida-paciente` : '';
}

/**
 * URL de cierre de sesión remoto en Vita360: al cerrar sesión en Vita360 App,
 * se cierra TAMBIÉN la sesión del paciente en Vita360 (sin dejar rastro) y se
 * aterriza en la bienvenida del portal paciente.
 */
export function intusLogoutUrl(): string {
  const base = intusBaseUrl();
  return base ? `${base}/patient/logout-remote` : '';
}

/**
 * Redirige el navegador al portal paciente de Vita360 (bienvenida). Se usa al
 * perder la sesión SSO: el login admin de Vita360 App es secreto y no debe
 * exponerse desde el flujo del paciente.
 */
export function redirectToIntus(): void {
  const url = intusWelcomeUrl();
  if (url) {
    window.location.replace(url);
  }
}

/**
 * Redirige el navegador al cierre de sesión remoto de Vita360 (logout del
 * paciente en ambos lados). Se usa en el logout explícito de Vita360 App.
 */
export function redirectToIntusLogout(): void {
  const url = intusLogoutUrl();
  if (url) {
    window.location.replace(url);
  }
}
